<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="c-modal" 
    >
      <div
        class="c-modal__overlay"
        @click="close"
      />      
      <div class="c-modal__content">
        <button
          type="button"
          class="c-modal__close"
          @click="close"
        >
          <img
            src="../../assets/icons/nav-close.svg"
            alt="close"
          >
          <span class="u-sr-only">Close Modal</span>
        </button>
        <slot name="content" />
      </div>
    </div>
  </transition>  
</template>

<script>
export default {
  name: 'Modal',
  props: {
    autoOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
    }
  },
  mounted() {
    if (this.autoOpen) {
      this.open();
    }
  },
  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
  },  
}
</script>

<style lang="scss" scoped>
.c-modal {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100vh;
  width: 100%;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.5);

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &__content {
    @include absoluteCenter;
    max-width: rem(600px);
    padding: rem(30px);
    @include themify($themes) {
      background-color: themed('background', 'base');
    }

    @include respond('phone') {
      width: calc(100% - 20px);
    }
    @include respond-min('tab-port') {
      width: 100%;
      max-width: rem(600px);
    }
  }

  &__close {
    appearance: none;
    background: none;
    border: 0;
    position: absolute;
    top: rem(10px);
    right: rem(10px);
    height: rem(44px);
    width: rem(44px);
    font-size: rem(36px);
    line-height: rem(44px);
    padding: rem(8px);
    text-align: center;

    img {
      display: block;
      width: 100%;
    }
  }
}
</style>